import React from 'react';
import styled from 'styled-components';

import { LoadingText } from './shared';

function LoadingCell({ height }) {
  return (
    <Cell $height={height}>
      <LoadingText />
    </Cell>
  );
};

LoadingCell.defaultProps = {
  height: 60
};

const Cell = styled.div`
  ${props => `height: ${props.height}px`};
  display: flex;
  align-items: center;
`;

export default LoadingCell;
